module.exports = __webpack_public_path__ + "img/handle.61874654.png";